<template>
  <div>
    <custom-callout
      class-main="mt-4 rounded"
      :has-border="false"
      :has-gradient="false"
      :has-toggle="false"
    >
      <div class="row w-100 gap">
        <div class="col bg-white board-radius p-4 rounded">
          <div class="color-black font-14">Cantidad a intervenir:</div>
          <div class="color-black font-weight-bold font-25">
            {{ this.executionSummary.amountToBeIntervened }}
          </div>
        </div>
        <div class="col bg-white board-radius p-4 rounded">
          <div class="color-black font-14">Cantidad intervenida:</div>
          <div class="color-black font-weight-bold font-25">
            {{ this.executionSummary.amountExecuted }}
          </div>
        </div>
        <div class="col bg-white board-radius p-4 rounded">
          <div class="row">
            <div class="col color-primary-6 font-14">
              <div class="d-inline">
                <custom-percentage
                  :percentage="this.executionSummary.percentageExecuted"
                  :show-percentace="false"
                  title=" % de intervención"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </custom-callout>
    <custom-separator class="my-4" text="Ejecuciones" />
    <custom-result-not-found
      v-if="!this.executionSummary.executionSummaryDetails.length"
      text="No hay información disponible."
    />
    <custom-callout
      v-for="(item, index) in this.executionSummary.executionSummaryDetails"
      :key="index"
      ref="detail-ref"
      class-main="mt-3 rounded"
      :has-toggle="false"
    >
      <div class="row py-2 mr-md-0 align-items-center">
        <div class="col-md-12 border-right">
          <div class="row">
            <div class="col-md-4">
              <span class="data-title d-block border-mobile">Fecha:</span>
            </div>
            <div class="col-md-4">
              <span class="data-title d-block border-mobile">Nombre:</span>
            </div>
            <div class="col-md-2">
              <span class="data-title d-block border-mobile">
                Usuario:
              </span>
            </div>
            <div class="col-md-2">
              <span class="data-title d-block border-mobile">
                Cantidad intervenida:
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <span class="font-16 color-black">
                {{ item.executionDate | date('DD/MMM/YYYY') }}
              </span>
            </div>
            <div class="col-md-4">
              <span class="font-16 color-black">
                {{ item.executorName }}
              </span>
            </div>
            <div class="col-md-2">
              <span class="font-16 color-black">
                {{ item.executorUserName }}
              </span>
            </div>
            <div class="col-md-2">
              <span class="font-16 color-black text-break">
                {{ item.amountExecuted }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </custom-callout>
  </div>
</template>

<script>
import { getExecutionSummary as _getExecutionSummary } from '@/services/provider/billing-contract.api';
import CustomSeparator from 'custom-separator';
import CustomCallout from 'custom-callout';
import CustomPercentage from 'custom-percentage';
import CustomResultNotFound from 'custom-result-not-found';

export default {
  name: 'BillingExecutionSummary',
  components: {
    CustomSeparator,
    CustomCallout,
    CustomPercentage,
    CustomResultNotFound,
  },
  data: () => ({
    executionSummary: {
      amountExecuted: 0,
      amountToBeIntervened: 0,
      percentageExecuted: 0,
      executionSummaryDetails: [],
    },
  }),
  props: {
    billId: {
      type: Number,
      default: () => 0,
    },
    billStatus: {
      type: Number,
      default: () => null,
    },
  },
  async mounted() {
    await this.getExecutionSummary();
  },
  methods: {
    async getExecutionSummary() {
      const { data } = await _getExecutionSummary(this.billId);
      if (data) this.executionSummary = data;
    },
  },
};
</script>
<style scoped lang="scss">
.gap {
  gap: 12px;
}

.custom-percentage {
  flex-direction: row-reverse;
  width: 185px;
}

::v-deep .custom-icon {
  .dot {
    width: 30px !important;
    height: 30px !important;
    .title-icon {
      margin-top: 2px;
      font-size: 15px;
    }
  }
}
</style>
